<template>
  <div class="statistics">
    <div class="stat">
      <span class="stat-label">Concentration problems: </span>
      <span class="stat-stat">{{ existingEntry.data.concentrationProblemLevel }}</span>
    </div>

    <div class="stat">
      <span class="stat-label">Memory problems: </span>
      <span class="stat-stat">{{ existingEntry.data.memoryProblemLevel }}</span>
    </div>

    <div class="stat">
      <span class="stat-label">Clarity of thought problems: </span>
      <span class="stat-stat">{{ existingEntry.data.memoryProblemLevel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["existingEntry"]
}
</script>

<style>

</style>
